import React from "react";
import cx from 'classnames';
import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import DeleteUserModal from "./DeleteUserModal";
import { openDeleteUserModal } from "../../actions/modalActions";
import messages from "../../locale/jsonMessages";
import { userRestriction } from '../../helpers/DemoRestriction/demoRestriction';
import showToaster from '../../helpers/toasterMessages/showToaster';

import arrow from '/public/siteImages/rightSideArrow.svg';
import cs from '../../components/commonStyle.css';

class DeleteUserForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isRestrict: false
        };
    }

    async componentDidMount() {
        const { userRestriction, profileId } = this.props;
        const isRestrict = await userRestriction({ restrictType: 'profile', restrictValue: profileId })
        this.setState({ isRestrict });
    }

    handleClick = () => {
        const { openDeleteUserModal } = this.props;

        const { isRestrict } = this.state;
        if (isRestrict) {
            showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
            return true;
        } else {
            openDeleteUserModal();
        }
    }

    render() {
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
                <DeleteUserModal />
                <h3 className={cx(cs.commonTotalText, cs.paddingBottom3)}>
                    {formatMessage(messages.deleteAccount)}
                </h3>
                <p className={cx(cs.commonMediumText, cs.paddingBottom3)}>
                    <span className={cs.fontWeightBold}>{formatMessage(messages.caution)}&nbsp;</span>
                    <span className={cs.fontWeightNormal}>{formatMessage(messages.deleteMessageContent)}</span>
                </p>
                <a href="javascript:void(0)" className={cx(cs.commonContentText, cs.siteLinkColor, cs.fontWeightMedium, cs.commonLinkBorderBottom, cs.textDecorationNone)} onClick={this.handleClick}>
                    {formatMessage(messages.deleteMessage)}
                    <img src={arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} />
                </a>
            </div>
        )
    }
}

const mapState = (state) => ({
    profileId: state?.account?.data?.profileId
});

const mapDispatch = {
    openDeleteUserModal,
    userRestriction
};

export default injectIntl(withStyles(cs)(connect(mapState, mapDispatch)(DeleteUserForm)));
